import {
  type DateRange,
  max,
  subDays,
  subMonths,
} from "@prismicio/editor-support/Date"
import { isDefined } from "@prismicio/editor-support/Type"
import {
  DateRangePicker,
  type DateRangePickerProps,
} from "@prismicio/editor-ui"

import { useSubscriptionQuery } from "../../settings/billing/useSubscription"

interface BillingPeriodPickerProps {
  dateRange: DateRange
  onDateRangeChange: (dateRange: DateRange) => void
}

export function BillingPeriodPicker(props: BillingPeriodPickerProps) {
  const { dateRange, onDateRangeChange } = props

  const { data: subscription } = useSubscriptionQuery()

  const yesterday = subDays(new Date(), 1)
  const oneYearAgo = subMonths(yesterday, 12)

  return (
    <BillingPeriodPickerTemplate
      onSubmit={onDateRangeChange}
      value={dateRange}
      minValue={
        isDefined(subscription.startDate)
          ? max([oneYearAgo, subscription.startDate])
          : oneYearAgo
      }
      maxValue={yesterday}
    />
  )
}

type BillingPeriodPickerTemplateProps<Value extends DateRange | null> = Pick<
  DateRangePickerProps<Value>,
  "disabled" | "maxValue" | "minValue" | "onSubmit" | "value"
>

function BillingPeriodPickerTemplate<Value extends DateRange | null>(
  props: BillingPeriodPickerTemplateProps<Value>,
) {
  return (
    <DateRangePicker
      {...props}
      fallback="Select a billing period"
      resetLabel="Reset to current period"
      triggerSize="medium"
    />
  )
}

export function BillingPeriodPickerSkeleton() {
  return <BillingPeriodPickerTemplate disabled value={null} />
}
